// extracted by mini-css-extract-plugin
export default {"ubButtonStyle":"styles_ubButtonStyle__RqE9F"};